/**
 * @generated SignedSource<<ab9757c34fb0134ba51041904ca2bd01>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedBannerModule_componentModule$data = {
  readonly cta: string | null;
  readonly ctaLink: string | null;
  readonly image: string | null;
  readonly mobileImage: string | null;
  readonly subText: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedFeaturedBannerModule_componentModule";
};
export type HpSharedFeaturedBannerModule_componentModule$key = {
  readonly " $data"?: HpSharedFeaturedBannerModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedBannerModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedBannerModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImage",
      "storageKey": null
    }
  ],
  "type": "BottomBannerModule",
  "abstractKey": null
};

(node as any).hash = "6a52f848056678d0a453a79a6e806d36";

export default node;
